export default "/images/vendor/@coreui/icons/svg/flag/cif-tm.svg?d50678ce18ee4ee1fa5739b25eece061";